<script setup lang="ts">
import { IconMenu2 } from '@tabler/icons-vue';

import { PRIMARY_COLOR } from '~/constants';
import useSidebar from '~/hooks/useSidebar';
import useAuth from '~/store/auth/useAuth';
import useLogout from '~/store/auth/useLogout';

const {
  data: user,
} = useAuth();

const logout = useLogout();

// Mobile sidebar integration
const { isMobile, toggleSidebar } = useSidebar();
</script>

<template>
  <header class="navbar navbar-expand-md d-print-none">
    <div class="container-header">
      <!-- Mobile hamburger button -->
      <button
        v-if="isMobile"
        class="navbar-toggler"
        type="button"
        aria-controls="sidebar-menu"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar">
        <IconMenu2 :size="24" />
      </button>
      <div class="navbar-nav flex-row order-md-last">
        <div class="d-none d-md-flex" />

        <div class="nav-item dropdown" aria-label="Open user menu" aria-expanded="false">
          <a href="#" class="nav-link d-flex lh-1 p-0 px-2">
            <span
              class="avatar avatar-sm d-flex align-items-center justify-content-center fw-bold text-white"
              :style="{ backgroundColor: PRIMARY_COLOR }"
            >
              {{ user?.keycloack.name?.charAt(0).toUpperCase() }}
            </span>
            <div class="d-none d-xl-block ps-2">
              <div>{{ user?.keycloack.name }}</div>
              <div class="mt-1 small text-secondary">
                {{ user?.person.profile.toLocaleLowerCase() }}
              </div>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow" data-bs-popper="static">
            <a href="#" class="dropdown-item">Status</a>
            <RouterLink to="/profile" class="dropdown-item">Perfil</RouterLink>
            <RouterLink to="/" class="dropdown-item">Feedback (em breve)</RouterLink>
            <div class="dropdown-divider" />

            <a href="#" class="dropdown-item">Configurações (em breve)</a>
            <button type="button" @click="() => logout.mutateAsync()" class="dropdown-item">
              <span v-if="logout.isPending.value">Saindo...</span>
              <span v-else>Logout</span>
            </button>
          </div>
        </div>
      </div>

      <div class="collapse navbar-collapse" id="navbar-menu">
        <div class="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
          <!-- BEGIN NAVBAR MENU -->
          <!-- END NAVBAR MENU -->
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 32px;
  width: 100%;
}

.navbar-toggler {
  border: none;
  background: none;
  color: #6c757d;
  transition: color 0.15s ease-in-out;
}

.navbar-toggler:hover {
  color: #495057;
}

.navbar-toggler:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.25);
}

@media (min-width: 992px) {
  .navbar-toggler {
    display: none;
  }
}
</style>
